<!--客户询价列表-->
<template>
  <div id="customerInquires" class="business-content-main">
    <div class="bread-nav">
      <div>您当前位置：</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客服</el-breadcrumb-item>
        <el-breadcrumb-item>询价管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户询价单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="search-ctn">
      <div class="search-name">询价单号:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchData.iCode"
        placeholder="请输入询价单号"
      ></el-input>
      <div class="search-name">客户名:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchData.cName"
        placeholder="请输入客户名"
      ></el-input>
      <div class="search-name">询价时间:</div>
      <el-date-picker
        :picker-options="startDateOps"
        class="search-item"
        v-model="searchData.startDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="date"
        size="small"
        placeholder="选择日期"
      ></el-date-picker>
      <span class="search-name">至</span>
      <el-date-picker
        :picker-options="endDateOps"
        class="search-item"
        v-model="searchData.endDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="date"
        size="small"
        placeholder="选择日期"
      ></el-date-picker>
      <div class="search-name">状态:</div>
      <el-select size="small" class="search-item" v-model="searchData.state" placeholder="请选择">
        <el-option
          v-for="item in orderState"
          :key="item.Tkey"
          :label="item.TValue"
          :value="item.Tkey"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        class="search-btn"
        @click="handleSearch"
      >查询</el-button>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-refresh"
        class="search-btn"
        @click="resetSearch"
      >重置</el-button>
    </div>
    <div class="table-ctn">
      <el-table
        :header-cell-style="{background:'#F2F6FC'}"
        :data="tableData"
        border=""
        style="width: 100%"
      >
        <el-table-column width="190px" show-overflow-tooltip prop="ICode" label="单号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="CName" label="客户名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Remark" label="备注"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Total" label="询价合计"></el-table-column>
        <el-table-column show-overflow-tooltip prop="NeedTime" label="期限时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="SubmitTimeStr" label="询价时间"></el-table-column>
        <el-table-column show-overflow-tooltip label="状态">
           <template slot-scope="scope">{{ scope.row.State|StateHandle }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope" >
            <el-button
              type="text"
              size="small"
              @click="showDialog(scope.row,'1')"
              v-if="permission.转内部询价&&scope.row.State== 0"
            >转内部询价</el-button>
            <el-button
              type="text"
              size="small"
              @click="showDialog(scope.row,'2')"
              v-if="permission.报价&&(scope.row.State== 0||scope.row.State== 2)"
            >报价</el-button>
             <el-button
              type="text"
              size="small"
              @click="showDialog(scope.row,'3')"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-ctn">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="searchData.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="searchData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableDataLength"
      ></el-pagination>
    </div>
    <el-dialog
      :title="IBDialogTitle"
      size="medium"
      width="85%"
      :visible.sync="IBDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="controlIBDialogVisible({visible:false})"
    >
      <!--用作注销元素-->
      <div v-if="IBDialogVisible">
        <transfromToIIqBill
          ref="transfromToIIqBill"
          @controlIBDialogVisible="controlIBDialogVisible"
          :objects="selectedApData"
          :action="action"
        ></transfromToIIqBill>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import transfromToIIqBill from "@/components/business/inquire/transfromToIIqBill.vue";
// import Vue from "vue";
export default {
  name: "company",
  components: {
    transfromToIIqBill
  },
  data() {
    return {
      startDateOps: {
        disabledDate: time => {
          return time.getTime() >= Date.now();
        }
      },
      endDateOps: {
        disabledDate: time => {
          return time.getTime() >= Date.now();
        }
      },
      formLabelWidth: "120px",
      orderState: [
        { Tkey: "-1",TValue: "不限" },
        { Tkey: "0", TValue: "待审核" },
        { Tkey: "1", TValue: "内部询价中" },
        { Tkey: "2", TValue: "内部询价完成" },
        { Tkey: "3", TValue: "已报价" },
        { Tkey: "4", TValue: "已作废" }
      ],
      searchData: {
        iCode: "",
        cName: "",
        state: "-1",
        startDate: "",
        endDate: "",
        page: 1, // 当前页数
        limit: 10 // 每页限制条数
      },
      tableData: [],
      tableDataLength: 0,
      permission: {},
      IBDialogVisible: false,
      IBDialogTitle:"",//弹窗标题
      selectedApData: {},//选中弹窗的数据对象
      action: ""//弹窗窗对应的操作：1转内部询价单，2报价，3查看
    };
  },
  mounted() {
    this.getTableData();
    this.$util.getPermission("客户询价单").then(res => {
      this.permission = res;
    });
  },
  filters: {
    StateHandle(value) {
      let result = "";
      switch (value) {
        case 0:
          result = "待审核";
          break;
        case 1:
          result = "内部询价中";
          break;
        case 2:
          result = "内部询价完成";
          break;
        case 3:
          result = "已报价";
          break;
        case 4:
          result = "已作废";
          break;
          default:
            result = "未知";
          break;
      }
      return result;
    }
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$refs.transToOrder.clearVal();
      this.dialogVisible = false;
    },

    showDialog(data, action) {
      this.selectedApData = data;
      this.action = action;
      switch(action){
        case "1" :this.IBDialogTitle='转内部询价：请选择询价的配件';break;
        case "2" :this.IBDialogTitle="向报价客户";break;
        case "3":this.IBDialogTitle="询价单详情";break;
      }
      this.IBDialogVisible = true;
    },
    getTableData() {
      let that = this;
      this.axios
        .get("/Inquiry/GetEntpInquiryBillsList", {
          params: that.searchData
        })
        .then(response => {
          if (response.data.errcode == 0 && response.data.data) {
            that.tableData = response.data.data;
            that.tableDataLength = response.data.count;
          }else{
              that.tableData = [];
              that.tableDataLength = 0;
          }
        })
        .catch(error => {
          console.log(error);
              that.tableData = [];
              that.tableDataLength = 0;
        });
    },

    //控制询价单弹窗是否展现 {visible, action}
    controlIBDialogVisible(data) {
      this.IBDialogVisible = data.visible;
        if (data.action == "save") {
         this.getTableData();
        }
    },
    handleSearch() {
      this.searchData.page = 1;
      this.getTableData();
    },
    resetSearch() {
      this.searchData = {
        iCode: "",
        cName: "",
        state: "-1",
        startDate: "",
        endDate: "",
        page: 1, // 当前页数
        limit: 10 // 每页限制条数
      };
    },
    handleSizeChange(val) {
      this.searchData.limit = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.searchData.page = val;
      this.getTableData();
    }
  }
};
</script>
<style lang="less" scoped>
</style>
